"use strict";

var novicell = novicell || {};
var dgv = dgv || {};


dgv.carousels = dgv.carousels || function () {

    function init() {
        // Check if carousel exists on page
        var carousel = document.querySelector('.concept__slider-carousel');

        if (!carousel) {
          return;
        }

        // If carousel exists, execute functions
        conceptSlider();
    }

    // TV product slider
    function conceptSlider() {
        var elem = document.querySelector('.concept__slider-carousel');
        var count = elem.getElementsByClassName('concept__slider-cell').length;

        // Slider options
        var options = {
          contain: true,
          pageDots: false,
          setGallerySize: false,
          resize: false,
          draggable: false,
          autoPlay: false,
          arrowShape: 'M80.0252476,29.6295518 C79.1920761,28.7901494 77.8053991,28.7901494 76.9430957,29.6295518 C76.1099243,30.4405959 76.1099243,31.7904456 76.9430957,32.5995992 L92.5713731,47.8128213 L2.15770052,47.8128213 C0.955525345,47.8147118 2.77555756e-15,48.7448603 2.77555756e-15,49.9151082 C2.77555756e-15,51.085356 0.955525345,52.0457533 2.15770052,52.0457533 L92.5713731,52.0457533 L76.9430957,67.2306172 C76.1099243,68.0700195 76.1099243,69.4217598 76.9430957,70.2309134 C77.8053991,71.0703157 79.1940183,71.0703157 80.0252476,70.2309134 L99.3532725,51.4162016 C100.215576,50.6051574 100.215576,49.2553077 99.3532725,48.4461541 L80.0252476,29.6295518 Z'
        };

        // If carousel contains more than one slide element, initialise it!
        if (count > 1) {
            // Build slider
            var flkty = new Flickity(elem, options);
            var carouselStatus = document.querySelector('.concept__slider-status');

            // Number of total
            function updateStatus() {
                var slideNumber = flkty.selectedIndex + 1;
                carouselStatus.textContent = slideNumber + '/' + flkty.slides.length;
            }
            updateStatus();

            flkty.on( 'select', updateStatus );
        }
  }

  return {
    init: init
  };

}();
